import { baixarModeloPlanilha, lerPlanilha } from "./importacaoPlanilha";

/**
 * Colunas da planilha de fornecedores. A de clientes reaproveita estas, sem a
 * previsão de pagamento (ver importacaoClientes.js).
 */
export const COLUNAS_IMPORTACAO = [
	{ campo: "nome", rotulo: "Nome", obrigatorio: true, apelidos: ["nome", "razaosocial", "fornecedor", "nomefornecedor", "nomedofornecedor", "razao", "produtor"] },
	{ campo: "nomeFantasia", rotulo: "Nome Fantasia", apelidos: ["nomefantasia", "fantasia"] },
	{ campo: "cpfCnpj", rotulo: "CPF/CNPJ", obrigatorio: true, apelidos: ["cpfcnpj", "cnpjcpf", "cpfoucnpj", "cnpj", "cpf", "documento"] },
	{ campo: "ieRg", rotulo: "IE/RG", apelidos: ["ierg", "rgie", "ie", "rg", "inscricaoestadual"] },
	{ campo: "email", rotulo: "E-mail", apelidos: ["email", "emails"] },
	{ campo: "telefone", rotulo: "Telefone", apelidos: ["telefone", "celular", "whatsapp", "fone", "telefonewhatsapp", "contato"] },
	{ campo: "cep", rotulo: "CEP", apelidos: ["cep"] },
	{ campo: "uf", rotulo: "UF", apelidos: ["uf", "estado"] },
	{ campo: "cidade", rotulo: "Cidade", apelidos: ["cidade", "municipio"] },
	{ campo: "bairro", rotulo: "Bairro", apelidos: ["bairro"] },
	{ campo: "logradouro", rotulo: "Logradouro", apelidos: ["logradouro", "endereco", "rua"] },
	{ campo: "latitude", rotulo: "Latitude", apelidos: ["latitude", "lat"] },
	{ campo: "longitude", rotulo: "Longitude", apelidos: ["longitude", "long", "lng", "lon"] },
	{
		campo: "dataEntradaBase",
		rotulo: "Data de entrada na base",
		apelidos: ["dataentradabase", "dataentradanabase", "datadeentradanabase", "datadeentradabase", "datadeentrada", "dataentrada", "entradabase", "entradanabase"],
	},
	{
		campo: "previsaoPagamentoDias",
		rotulo: "Previsão de pagamento (dias)",
		apelidos: ["previsaodepagamentodias", "previsaopagamentodias", "previsaopagamento", "previsaodepagamento", "prazopagamento", "prazodepagamento", "prazopagamentodias", "diaspagamento", "pagamentodias"],
	},
	{ campo: "produtos", rotulo: "Produtos", apelidos: ["produtos", "produto", "cultivos", "cultivo", "culturas", "cultura"] },
];

export function lerPlanilhaFornecedores(file) {
	return lerPlanilha(file, COLUNAS_IMPORTACAO, { exemploCabecalho: "Nome, CPF/CNPJ, Telefone", entidade: "fornecedor" });
}

/** Instruções comuns a fornecedores e clientes, por campo. */
export const INSTRUCOES_CADASTRO = {
	cpfCnpj: (entidade) => ["CPF/CNPJ", `Com ou sem pontuação. ${entidade} com CPF/CNPJ já cadastrado não é duplicado nem alterado.`],
	latitudeLongitude: ["Latitude / Longitude", "Em graus decimais, vírgula ou ponto (ex.: -22,9056 e -47,0608). Preencha as duas ou nenhuma."],
	dataEntradaBase: ["Data de entrada na base", "No formato dd/mm/aaaa."],
	produtos: [
		["Produtos", "Vários produtos separados por ponto e vírgula. Cada um no formato \"Cultura - Variedade (unidade)\", igual ao nome do cultivo no sistema; a unidade entre parênteses é opcional (kg, un...)."],
		["", "Só entra produto que exista no cadastro de cultivos do sistema. Produto sem correspondência é ignorado e aparece como aviso na prévia."],
	],
};

/** Gera e baixa o modelo em Excel com as colunas aceitas, uma linha de exemplo e as instruções. */
export function baixarModeloImportacao() {
	baixarModeloPlanilha({
		colunas: COLUNAS_IMPORTACAO,
		exemplo: [
			"Sítio Boa Vista Ltda",
			"Boa Vista Hortifruti",
			"12.345.678/0001-95",
			"123.456.789.000",
			"contato@boavista.com.br",
			"(11) 99999-8888",
			"13000-000",
			"SP",
			"Campinas",
			"Centro",
			"Estrada Municipal, km 12",
			"-22,9056",
			"-47,0608",
			"15/01/2025",
			"30",
			"Alface - Crespa (kg); Tomate - Cereja (un)",
		],
		instrucoes: [
			["Como preencher a planilha de fornecedores"],
			[],
			["Obrigatórios", "Nome e CPF/CNPJ. As demais colunas são opcionais e podem ficar vazias."],
			INSTRUCOES_CADASTRO.cpfCnpj("Fornecedor"),
			["Telefone", "Com DDD. É o número usado nas mensagens de WhatsApp."],
			INSTRUCOES_CADASTRO.latitudeLongitude,
			INSTRUCOES_CADASTRO.dataEntradaBase,
			["Previsão de pagamento (dias)", "Número inteiro de dias."],
			...INSTRUCOES_CADASTRO.produtos,
		],
		aba: "Fornecedores",
		arquivo: "modelo-importacao-fornecedores.xlsx",
	});
}
